<template>

  <v-card class="elevation-12" max-width="960">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Privacy policy</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <h3>1. Informazioni generali e tipologia di dati trattati</h3>

      <p>
        Desideriamo informarti che il Regolamento generale sulla
        protezione dei dati n. 679/2016/EU (General Data Protection
        Regulation – “GDPR”) prevede la tutela delle persone e di altri
        soggetti rispetto al trattamento dei dati personali. Secondo la
        normativa indicata, tale trattamento sarà improntato ai principi
        di correttezza, liceità, trasparenza e tutela della tua
        riservatezza e dei tuoi diritti. Ai sensi dell’articolo 13 del
        GPDR, ti forniamo le seguenti informazioni su come trattiamo i
        dati personali forniti dagli utenti nel corso dell’utilizzo
        dell’applicazione “WebApp della {{ campaignName }} promosse da
        {{ companyName }}
      </p>

      <h3>2. Titolare del trattamento</h3>
      <p>
        Titolare del trattamento è l’azienda {{ companyName }} con sede
        legale . Puoi contattare il titolare scrivendo una email al
        seguente indirizzo email:……………..
      </p>

      <h3>3. Responsabile del trattamento</h3>

      <p>
        Responsabile del trattamento è Donapp S.r.l., con sede legale in
        Roma, via Raffaele Conforti 130, Italia (“Donapp”). Puoi
        contattare il responsabile scrivendo una email al seguente
        indirizzo email: info@donapp.it
      </p>

      <h3>4. Modalità e finalità del trattamento dei dati personali</h3>
      <p>
        I dati personali forniti dagli utenti , quando richiesti in base
        al regolamento della campagna, saranno oggetto di trattamento,
        mediante strumenti informatici, per le seguenti finalità:
      </p>
      <ol type="a">
        <li>
          dare esecuzione ai termini e condizioni d’uso della WebAPP
          previso dal regolamento della {{ campaignName }}, anche
          attraverso attività di geolocalizzazione quando richiesto
          (queste ultime, previo consenso espresso dell’utente). In tale
          ipotesi, la base giuridica del trattamento è costituita
          dall’accettazione esplicita da parte dell’utente attraverso la
          WebApp
        </li>
        <li>
          gestione delle indicazioni fornite dagli utenti riguardo le
          iniziative di solidarietà legate alla campagna,
        </li>
        <li>
          gestione delle eventuali offerte commerciali collegate alla
          campagna;
        </li>
        <li>
          rispondere alle richieste degli utenti così come inoltrate a
          {{ companyName }} ; nei casi di cui alle precedenti lettere
          a), b), c) e d), la base giuridica del trattamento dei dati
          degli utenti è costituita dall’adesione all’iniziativa in base
          alla presa visione del regolamento della campagna,
        </li>
        <li>
          adempiere ad obblighi di legge o derivanti dalle norme UE. In
          tale ipotesi, la base giuridica del trattamento è costituita
          da una norma di legge; nel caso di cui alla precedente lettera
          e), la base giuridica è costituita da una norma di legge;
        </li>
        <li>
          previo consenso degli utenti, condurre iniziative promozionali
          inerenti le attività sub a), b) e c), nonché raccogliere dagli
          utenti suggerimenti al fine di migliorare i servizi resi;
        </li>
        <li>
          previo consenso degli utenti, effettuare la profilazione degli
          utenti, nei casi di cui alle precedenti lettere f) e g), la
          base giuridica è costituita del consenso degli utenti, che
          potrà essere revocato successivamente in qualsiasi momento. Il
          conferimento dei dati personali , quando richiesti, per le
          finalità di cui alle precedenti lettere a), b), c), d) ed e) è
          obbligatorio, in quanto necessario, rispettivamente, (i) ad
          eseguire i termini e condizioni d’uso della WebApp (ii) ad
          adempiere ad obblighi di legge.
        </li>
      </ol>
      <p>
        Il conferimento dei dati per le finalità di cui alle lettere f)
        e g) è facoltativo; tuttavia, il rifiuto di fornire i dati
        personali determinerà, rispettivamente, l’impossibilità di
        ricevere pubblicità personalizzata e/o comunicazioni
        promozionali.
      </p>

      <h3>5. Trattamento dei dati personali dei minori</h3>
      <p>
        {{ companyName }} non compie alcuna operazione di trattamento di
        dati personali relativi a minorenni. {{ companyName }} invita
        tutti gli utenti che non abbiano compiuto 18 anni a non
        comunicare in nessun caso i propri dati personali, riservandosi
        il diritto di inibire l’accesso ai servizi a qualsiasi utente
        che abbia celato la propria minore età o che abbia comunque
        comunicato i propri dati personali in assenza del consenso dei
        propri genitori pur avendo un’età inferiore ai 18 anni.
      </p>

      <h3>6. Diritti degli utenti</h3>
      <p>
        Ai sensi del GDPR, gli utenti sono titolari dei seguenti
        diritti:
      </p>
      <ol type="a">
        <li>
          chiedere accesso ai dati personali (c.d. “richiesta di accesso
          dell’interessato”), in modo da ricevere una copia dei dati
          personali che li riguardano e di verificare che {{ companyName }}
          li stia trattando in modo lecito;
        </li>
        <li>
          chiedere la rettifica dei Dati Personali, in modo da
          modificare qualsiasi informazione incompleta o non corretta
          utilizzata da {{ companyName }};
        </li>
        <li>
          chiedere la cancellazione dei Dati Personali, in modo da
          ottenere dall’ {{ companyName }} che promuove la campagne in
          cui è prevista la registrazione, la cancellazione o rimozione
          dei suoi Dati Personali se non c’è una valida ragione per
          continuare ad utilizzarli;
        </li>
        <li>
          opporsi al trattamento dei Dati Personali, quando
          {{ companyName }} li utilizza in base a un legittimo interesse
          proprio o di un terzo, e la sua situazione specifica la induce
          a opporsi a tale utilizzo;
        </li>
        <li>
          revocare il suo consenso, nel caso in cui gli utenti abbiano
          fornito il consenso alla raccolta, trattamento e trasferimento
          dei Dati Personali per una finalità specifica, in qualsiasi
          momento. Una volta ricevuta tale richiesta,
          {{ companyName }} non utilizzerà più i suoi Dati Personali per
          quella/e finalità, salvo sussista un’ulteriore base legale;
        </li>
        <li>
          chiedere la limitazione del trattamento dei Dati Personali, in
          modo che {{ companyName }}
          .sospenda il trattamento dei Dati Personali, ad esempio in
          caso di richiesta di verifica dell’esattezza o del motivo per
          {{ companyName }} li utilizza;
        </li>
        <li>
          chiedere il trasferimento dei suoi Dati Personali a un altro
          soggetto (c.d. “portabilità dei dati”);
        </li>
        <li>
          proporre reclamo al Garante per la protezione dei dati
          personali. Gli utenti sono invitati a presentare le richieste
          di esercizio dei diritti all'indirizzo ………………
        </li>
      </ol>

      <h3>7. Trasferimento di dati personali a soggetti terzi</h3>

      <p>
        I dati personali forniti dagli utenti saranno trattati da
        responsabili e incaricati del {{ companyName }} non saranno in
        alcun caso diffusi, ma potranno essere comunicati – per le
        medesime finalità per cui è effettuata la raccolta – a terzi
        appartenenti alle seguenti categorie: soggetti che forniscono
        servizi collegati alla campagna. Una lista dei responsabili del
        trattamento nominati da {{ companyName }} è disponibile, su
        richiesta, presso la sede di via ……………..
      </p>

      <h3>8. Modifiche e aggiornamenti</h3>

      <p>
        {{ companyName }} potrà liberamente modificare, integrare e/o
        aggiornare, in tutto o in parte, la presente privacy policy,
        anche in considerazione di futuri cambiamenti che potranno
        intervenire sulle disposizioni di legge applicabili in materia
        di protezione dei dati personali.
      </p>
    </v-card-text>
  </v-card>

</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      companyName: 'NOME AZIENDA',
      campaignName: 'NOME CAMPAGNA',
      component: 'registration-form',
      registratioData: {}
    }
  }
}
</script>
<style scoped>
li {
  margin-bottom: 16px;
}
</style>
